import client from "../utils/ApiClient";
import * as url from "./url_helper";

const options = {
  method: "GET",
  url: "",
  headers: {
    "content-type": "application/json",
  },
};

export const getAPIKey = async () => {
  options.method = "GET";
  options.url = url.GET_API_KEY;
  await client
    .request(options)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error;
    });
};

//// LOGIN API

// postForgetPwd
export const postForgetPwd = async (data) => {
  return await client.get(url.POST_PASSWORD_FORGET, { params: data });
};

export const passwordReset = async (data) => {
  return await client.post(url.POST_PASSWORD_RESET, data);
};

export const passwordSet = async (data) => {
  return await client.post(url.POST_PASSWORD_SET, data);
};

// Edit profile
export const postJwtProfile = async (data) => {
  options.method = "POST";
  options.url = url.POST_EDIT_JWT_PROFILE;
  options.data = data;
  await client
    .request(options)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error;
    });
};

// Login Method
export const postLogin = async (data) => {
  options.method = "GET";
  options.url = url.POST_LOGIN;
  options.params = data;
  return await client.get(options.url, { params: data });
};

// Login Method
export const postProfile = async (data) => {
  return await client.post(url.POST_EDIT_PROFILE, data);
};

// Login Method
export const postRegister = async (data) => {
  options.method = "POST";
  options.url = url.POST_REGISTER;
  options.data = data;
  return await client.post(options.url, data);
};

export const postRegisterTrial = async (data) => {
  options.method = "POST";
  options.url = url.POST_REGISTER_TRIAL;
  options.data = data;
  return await client.post(options.url, data);
};

export const getTrialDays = async () => {
  return await client.get(url.GET_TRIAL_DAYS);
};

export const editUser = async (data) => {
  return await client.put(url.EDIT_USER, data, {
    headers: {
      "content-type": "application/json",
    },
  });
};

/// Products API

export const getProducts = async (data) => {
  return await client.get(url.GET_PRODUCTS, { params: data });
};
export const getProductById = async (data) => {
  return await client.get(url.GET_PRODUCTS_BY_ID, { params: data });
};
export const getHotProducts = async (data) => {
  return await client.get(url.GET_HOT_PRODUCTS, { params: data });
};
export const getMyProducts = async (data) => {
  return await client.get(url.GET_MY_PRODUCTS, { params: data });
};
export const addNewProduct = async (data) => {
  return await client.post(url.ADD_NEW_PRODUCT, data);
};
export const updateProduct = async (data) => {
  return await client.put(url.UPDATE_PRODUCT, data);
};

export const deleteProducts = async (data) => {
  return await client.delete(url.DELETE_PRODUCT, data);
};

export const setProductFlag = async (data) => {
  return await client.get(url.SET_PRODUCT_FLAG, { params: data });
};

export const downloadProducts = async (data) => {
  return await client.get(url.DOWNLOAD_PRODUCTS, { params: data });
}

/// Orders API

export const getOrders = async (data) => {
  return await client.get(url.ORDERS, { params: data });
};
export const addNewOrder = async (data) => {
  return await client.post(url.ORDERS, data);
};
export const updateOrder = async (data) => {
  return await client.put(url.ORDERS, data);
};

export const deleteOrder = async (data) => {
  return await client.delete(url.DELETE_ORDER, data);
};
export const cancelOrder = async (data) => {
  return await client.post(url.CANCEL_ORDER, data);
};
export const getInvoice = async (data) => {
  return await client.get(url.GET_INVOICE, { params: data });
};

/// Import Files API
export const getFiles = async (data) => {
  return await client.get(url.GET_FILES, data);
};
export const getSuppliers = async (data) => {
  return await client.get(url.GET_SUPPLIERS, data);
};
export const importFile = async (data) => {
  var response = await client.post(url.IMPORT_FILE, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

//ANALYSIS
export const getImports = async (data) => {
  return await client.post(url.GET_IMPORTS, data);
};

export const updateRow = async (data) => {
  return await client.put(url.UPDATE_ROW, data, {
    headers: {
      "content-type": "application/json",
    },
  });
};

export const updateStatus = async (data) => {
  return await client.put(url.UPDATE_STATUS, JSON.stringify(data), {
    headers: {
      "content-type": "application/json",
    },
  });
};

export const getSettings = async (data) => {
  return await client.get(url.GET_SETTINGS, data);
};

export const updateSettings = async (data) => {
  return await client.put(url.UPDATE_SETTINGS, data);
};

export const getGlobalSettings = async (data) => {
  return await client.get(url.GET_GLOBAL_SETTINGS, data);
};

export const getNotifications = async (data) => {
  return await client.get(url.GET_NOTIFICATIONS, data);
};

export const changeStatusNotification = async (data) => {
  return await client.get(url.CHANGE_STATUS, { params: data });
};

export const getDefaultPayment = async (data) => {
  return await client.get(url.GET_DEFAULT_PAYMENT, data);
};

export const getPlanInformation = async (data) => {
  return await client.get(url.GET_PLAN_INFORMATION, data);
};

export const updatePayment = async (data) => {
  return await client.get(url.UPDATE_PAYMENT, { params: data });
};

export const switchPlan = async (data) => {
  return await client.get(url.SWITCH_PLAN, { params: data });
};
export const cancelPlan = async (data) => {
  return await client.get(url.CANCEL_PLAN, { params: data });
};

export const unCancelPlan = async (data) => {
  return await client.get(url.UNCANCEL_PLAN, { params: data });
};

// Subscription Frequency API
export const getSubscriptionFrequencies = async () => {
  return await client.get(url.GET_SUBSCRIPTION_FREQUENCIES);
};

export const getStripeSubscriptions = async (token, frequency) => {
  return await client.get(url.GET_STRIPE_SUBSCRIPTIONS, { params: { token, frequency } });
};

export const createSubscription = async (data) => {
  return await client.get(url.CREATE_SUBSCRIPTION, { params: data });
};

export const createGhostSubscription = async (data) => {
  return await client.get(url.CREATE_GHOST_SUBSCRIPTION, { params: data });
};

export const createGhostSubscriptionCustom = async (frequency, token) => {
  const params = token ? { frequency, token } : { frequency };
  return await client.get(url.CREATE_GHOST_SUBSCRIPTION_CUSTOM, { params });
};

// Quick Start
export const updateQuickStartStep = async (data) => {
  return await client.put(url.QUICK_START_STEP, null, { params: data });
};
export const updateChannelsAdded = async (data) => {
  return await client.put(url.CHANNELS_ADDED, null, { params: data });
};
